import { FC } from 'react'

import { Box } from '@mui/material'

import usePage from '../../../hooks/usePage'
import pageService from '../../../services/PageService'
import { UsersList } from '../../features/users/components/UsersList/UsersList'

export const UsersPage: FC = () => {
  usePage(pageService.getInternalPageWithId('internal-users'))

  return (
    <Box>
      <UsersList />
    </Box>
  )
}
